import styled from 'styled-components';

const Root = styled.div`
  cursor: pointer;
  display: flex;
  gap: 0.25rem;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: 2rem;
  border-radius: 2rem;
  flex-shrink: 0;
  padding-left: 0.625rem;
  padding-right: 0.75rem;
  color: var(--text-tertiary);
  background-color: var(--tonal);
  font-size: 0.875rem;
  font-weight: 500;
  &:hover {
    background-color: var(--tonal-deep);
  }
  &:active {
    background-color: var(--tonal-deep);
  }
  .material-symbols-rounded {
    font-size: 1.125rem;
    font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;
  }
  &.small {
    height: 1.5rem;
    gap: 0.125rem;
  }
  &.blue {
    background-color: var(--tonal-blue);
    color: var(--primary);
    &:hover {
      background-color: var(--tonal-deep-blue);
    }
    &.light {
      background-color: #eef2ff;
      color: var(--blue-500);
      &:hover {
        background-color: var(--indigo-100);
      }
    }
    &.dark {
      background-color: #212e48;
      background-color: var(--sky-900);
      color: var(--blue-400);
      &:hover {
        background-color: var(--sky-800);
      }
    }
  }
  &.red {
    background-color: var(--tonal-red);
    color: var(--filled-red);
    &:hover {
      background-color: var(--tonal-deep-red);
    }
    &.light {
      background-color: #fff5f8;
      color: var(--rose-500);
      &:hover {
        background-color: var(--red-100);
      }
    }
    &.dark {
      background-color: #3a2434;
      color: var(--rose-500);
      &:hover {
        background-color: var(--red-900);
      }
    }
  }
`;

type Props = {
  icon?: string;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  text: string;
  color?: 'blue' | 'red';
  size?: 'small';
  fixTheme?: 'dark' | 'light';
};

const SmallIconWidthTextButton = ({ icon, onClick, text, color, size, fixTheme }: Props) => {
  const style = () => {
    return `${color ?? ''} ${size ?? ''} ${fixTheme ?? ''}`;
  };
  return (
    <Root role='button' tabIndex={0} onClick={onClick} className={style()}>
      {icon && <span className='material-symbols-rounded'>{icon}</span>}
      {text}
    </Root>
  );
};

export default SmallIconWidthTextButton;
